import { render, staticRenderFns } from "./ScatterChartSimple.vue?vue&type=template&id=4be356b1&"
import script from "./ScatterChartSimple.vue?vue&type=script&lang=js&"
export * from "./ScatterChartSimple.vue?vue&type=script&lang=js&"
import style0 from "./ScatterChartSimple.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports